<template>
	<v-card v-if="item">
		<v-container>
			<v-layout justify-space-between class="question-header mb-2">
				<h2 class="question-title title">{{ item.title }}</h2>
				<navigation :id="item.id" />
			</v-layout>
			<v-layout :row="row" :column="!row" class="mb-4" wrap="true">
				<template v-for="(option, i) in compOptions">
					<v-tooltip v-if="option.text" :key="i + 'p'" bottom max-width="66%">
						<template v-slot:activator="{ on }">
							<v-btn
								:to="{ name: 'page', params: { id: option.target } }"
								color="primary"
								v-on="on"
								:id="`abfr_${item.slug}_${option.slug}`"
							>
								{{ option.label }}
							</v-btn>
						</template>
						<span><strong>Hinweis:</strong> {{ option.text }}</span>
					</v-tooltip>
					<v-btn
						v-else
						:to="{ name: 'page', params: { id: option.target } }"
						color="primary"
						:key="i"
						:id="`abfr_${item.slug}_${option.slug}`"
					>
						{{ option.label }}
					</v-btn>
				</template>
			</v-layout>
			<div v-if="item.text" class="question-body body-1">
				<strong>Hinweis:</strong>
				<div v-html="item.text"></div>
			</div>
		</v-container>
	</v-card>
</template>

<style>
.question-header {
	flex-wrap: wrap;
}
.question-title {
	order: 999;
}

.question-body strong {
	float: left;
	margin-right: 0.25em;
}

@media screen and (min-width: 412px) {
	.question-title {
		flex-basis: 74%;
	}

	.question-header {
		flex-wrap: nowrap;
	}
	.question-title {
		order: 0;
	}
}
</style>

<script>
import Navigation from './Navigation.vue';
import { mapState } from 'vuex';

export default {
	props: ['item'],
	components: {
		Navigation,
	},
	computed: {
		...mapState(['noticegt3weeks', 'commicementgt6months', 'before2004']),
		compOptions() {
			return this.item.options.map(option => {
				const { target } = option;
				const { noticegt3weeks, commicementgt6months, before2004 } = this;

				if (typeof target === 'string') {
					return option;
				}

				const actionMap = {
					noticegt3weeks() {
						return target[
							target.condition === 'noticegt3weeks' && noticegt3weeks
								? 'if'
								: 'else'
						];
					},
					commicementgt6months() {
						return target[
							target.condition === 'commicementgt6months' &&
							commicementgt6months
								? 'if'
								: 'else'
						];
					},
					before2004() {
						return target[
							target.condition === 'before2004' && before2004 ? 'if' : 'else'
						];
					},
				};

				return {
					...option,
					target: actionMap[target.condition](),
				};
			});
		},
		row() {
			const noText = this.item.options.every(o => !o.text);

			if (this.$vuetify.breakpoint.xsOnly) {
				return false;
			}

			return noText || this.item.options.length < 4;
		},
	},
};
</script>
